/**
 * mega-menu-impulse.js — v4c
 *
 * Gebaseerd op v4. Wijzigingen:
 *  - Panel wordt naar document.body verplaatst (buiten header stacking context)
 *    zodat het BOVEN de overlay verschijnt → klikken werkt
 *  - .is-open class op het panel zelf (niet alleen op de <li>)
 *  - syncTop zet top + left op basis van #SiteHeader
 *  - Scrollbar werkt via CSS max-height + overflow-y
 */

(function () {
  'use strict';

  var megaItems   = [];
  var panelMap    = [];        /* { item, panel, originalParent } */
  var overlay     = null;
  var openItem    = null;
  var openPanel   = null;
  var rafId       = null;
  var lastX       = 0;
  var lastY       = 0;
  var listenersAttached = false;

  /* ── Helpers ─────────────────────────────────────────────── */
  function hitTest(el, x, y) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
  }

  function getPanelForItem(item) {
    for (var i = 0; i < panelMap.length; i++) {
      if (panelMap[i].item === item) return panelMap[i].panel;
    }
    return null;
  }

  function cursorIsInsideMenu(x, y) {
    if (!openItem || !openPanel) return false;

    /* 1. Cursor in het panel */
    if (hitTest(openPanel, x, y)) return true;

    var liRect    = openItem.getBoundingClientRect();
    var panelRect = openPanel.getBoundingClientRect();

    /* 2. Cursor in de gap tussen nav-balk en panel */
    if (
      y >= liRect.top     &&
      y <= panelRect.top  &&
      x >= panelRect.left &&
      x <= panelRect.right
    ) return true;

    /* 3. Cursor op de <li> trigger */
    return hitTest(openItem, x, y);
  }

  function syncTop() {
    var header = document.getElementById('SiteHeader')
              || document.querySelector('.site-header');
    if (!header) return;
    var bottom = header.getBoundingClientRect().bottom;

    panelMap.forEach(function (entry) {
      var panel = entry.panel;
      var itemRect = entry.item.getBoundingClientRect();
      panel.style.top  = Math.round(bottom) + 'px';
      panel.style.left = Math.round(itemRect.left) + 'px';
    });
  }

  function resetSubs(panel) {
    panel.querySelectorAll('[data-mega-sidebar-item]').forEach(function (si) {
      si.classList.remove('is-active');
      var btn = si.querySelector('[data-mega-sidebar-trigger]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
    panel.querySelectorAll('[data-mega-sub-content]').forEach(function (sc) {
      sc.classList.remove('is-active');
    });
    var col = panel.querySelector('[data-mega-sub-column]');
    if (col) col.classList.remove('has-active');
  }

  function openMenu(item) {
    if (openItem === item) return;
    if (openItem) closeMenu();

    var panel = getPanelForItem(item);
    if (!panel) return;

    syncTop();
    openItem  = item;
    openPanel = panel;

    item.classList.add('is-open');
    panel.classList.add('is-open');

    var link = item.querySelector('.site-nav__link');
    if (link) link.setAttribute('aria-expanded', 'true');
    if (overlay) overlay.classList.add('is-active');
  }

  function closeMenu() {
    if (!openItem) return;

    openItem.classList.remove('is-open');
    var link = openItem.querySelector('.site-nav__link');
    if (link) link.setAttribute('aria-expanded', 'false');

    if (openPanel) {
      openPanel.classList.remove('is-open');
      resetSubs(openPanel);
    }

    if (overlay) overlay.classList.remove('is-active');
    openItem  = null;
    openPanel = null;
  }

  /* ── Teardown ────────────────────────────────────────────── */
  function teardown() {
    closeMenu();

    /* Panels terugzetten naar originele plek */
    panelMap.forEach(function (entry) {
      if (entry.originalParent && entry.panel.parentNode === document.body) {
        entry.originalParent.appendChild(entry.panel);
      }
    });

    megaItems = [];
    panelMap  = [];

    if (overlay && overlay.parentNode) {
      overlay.parentNode.removeChild(overlay);
    }
    overlay = null;
  }

  /* ── Init ────────────────────────────────────────────────── */
  function init() {
    teardown();

    megaItems = Array.prototype.slice.call(
      document.querySelectorAll('.site-nav__item--mega')
    );
    if (!megaItems.length) return;

    /* Panels naar document.body verplaatsen */
    megaItems.forEach(function (item) {
      var panel = item.querySelector('.mega-nav');
      if (!panel) return;
      var originalParent = panel.parentNode;
      document.body.appendChild(panel);
      panelMap.push({ item: item, panel: panel, originalParent: originalParent });
    });

    /* Overlay */
    overlay = document.createElement('div');
    overlay.className = 'mega-nav-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    document.body.appendChild(overlay);
    overlay.addEventListener('click', closeMenu);

    /* Document-level listeners — eenmalig */
    if (!listenersAttached) {
      listenersAttached = true;

      document.addEventListener('mousemove', function (e) {
        lastX = e.clientX;
        lastY = e.clientY;
        if (rafId) return;
        rafId = requestAnimationFrame(function () {
          rafId = null;
          if (!megaItems.length) return;

          if (openItem && !cursorIsInsideMenu(lastX, lastY)) {
            closeMenu();
            return;
          }
          for (var i = 0; i < megaItems.length; i++) {
            if (hitTest(megaItems[i], lastX, lastY)) {
              openMenu(megaItems[i]);
              break;
            }
          }
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && openItem) {
          var trigger = openItem.querySelector('.site-nav__link');
          closeMenu();
          if (trigger) trigger.focus();
        }
      });

      window.addEventListener('scroll', function () { syncTop(); }, { passive: true });
      window.addEventListener('resize', function () { syncTop(); }, { passive: true });
    }

    /* Per-panel: sub-kolom wisselen + toetsenbord */
    panelMap.forEach(function (entry) {
      var item        = entry.item;
      var panel       = entry.panel;
      var dataPanel   = panel.querySelector('[data-mega-panel]') || panel;
      var sidebarBtns = panel.querySelectorAll('[data-mega-sidebar-trigger]');
      var subContents = panel.querySelectorAll('[data-mega-sub-content]');
      var subColumn   = panel.querySelector('[data-mega-sub-column]');
      var plainLinks  = panel.querySelectorAll('.mega-nav__sidebar-link');

      sidebarBtns.forEach(function (btn, idx) {
        function activate() {
          panel.querySelectorAll('[data-mega-sidebar-item]').forEach(function (si) {
            si.classList.remove('is-active');
            var b = si.querySelector('[data-mega-sidebar-trigger]');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          subContents.forEach(function (sc) { sc.classList.remove('is-active'); });

          var parentItem = btn.closest('[data-mega-sidebar-item]');
          if (parentItem) parentItem.classList.add('is-active');
          btn.setAttribute('aria-expanded', 'true');
          if (subContents[idx]) subContents[idx].classList.add('is-active');
          if (subColumn) subColumn.classList.add('has-active');
        }
        btn.addEventListener('mouseenter', activate);
        btn.addEventListener('focus',      activate);
      });

      plainLinks.forEach(function (link) {
        link.addEventListener('mouseenter', function () {
          subContents.forEach(function (sc) { sc.classList.remove('is-active'); });
          panel.querySelectorAll('[data-mega-sidebar-item]').forEach(function (si) {
            si.classList.remove('is-active');
            var b = si.querySelector('[data-mega-sidebar-trigger]');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (subColumn) subColumn.classList.remove('has-active');
        });
      });

      var navLink = item.querySelector('.site-nav__link');
      if (navLink) {
        navLink.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
            e.preventDefault();
            if (item.classList.contains('is-open')) {
              closeMenu();
              navLink.focus();
            } else {
              openMenu(item);
              var first = dataPanel.querySelector('button, [href]');
              if (first) first.focus();
            }
          }
        });
      }

      dataPanel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          var trigger = item.querySelector('.site-nav__link');
          closeMenu();
          if (trigger) trigger.focus();
        }
      });
    });

    syncTop();
  }

  /* ── Bootstrap ───────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', function (e) {
    var sectionEl = e.target;
    if (
      sectionEl &&
      (sectionEl.querySelector('.site-nav__item--mega') ||
       sectionEl.getAttribute('data-section-type') === 'header')
    ) init();
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var sectionEl = e.target;
    if (
      sectionEl &&
      (sectionEl.querySelector('.site-nav__item--mega') ||
       sectionEl.getAttribute('data-section-type') === 'header')
    ) teardown();
  });

  document.addEventListener('shopify:block:select', syncTop);
  document.addEventListener('shopify:block:deselect', function () {
    closeMenu();
    syncTop();
  });

})();